// =============================================================================
// navigation/AuthStack.tsx — the auth + onboarding stack (P3 AUTH group).
//
// Drives two of the root gate's branches (blueprint §2 [GATE]):
//   - 'unauthed'   → AuthStack with initialRouteName="Login"
//   - 'onboarding' → AuthStack with initialRouteName="Onboarding"
// App.tsx passes `initialRouteName` based on useAuth().state so the same stack
// serves both branches without a second navigator. All five screens are always
// registered; only the entry point differs.
// =============================================================================
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import type { AuthStackParamList } from './types';
import LoginScreen from '../screens/LoginScreen';
import RegisterScreen from '../screens/RegisterScreen';
import ForgotPasswordScreen from '../screens/ForgotPasswordScreen';
import ResetPasswordScreen from '../screens/ResetPasswordScreen';
import OnboardingScreen from '../screens/OnboardingScreen';
import LegalScreen from '../screens/LegalScreen';

const Stack = createNativeStackNavigator<AuthStackParamList>();

export function AuthStack({
  initialRouteName = 'Login',
}: {
  initialRouteName?: keyof AuthStackParamList;
}) {
  return (
    <Stack.Navigator
      initialRouteName={initialRouteName}
      screenOptions={{ headerShown: false, animation: 'fade' }}
    >
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Register" component={RegisterScreen} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} />
      <Stack.Screen name="ResetPassword" component={ResetPasswordScreen} />
      <Stack.Screen name="Onboarding" component={OnboardingScreen} />
      <Stack.Screen name="Legal" component={LegalScreen} />
    </Stack.Navigator>
  );
}
